// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 70,
  H_DESKTOP: 70,
  H_DESKTOP_OFFSET: 60,
  H_MOBILE_OFFSET: 0,
  H_DESKTOP_SUBMENU_OFFSET: 55,
};
export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};
